"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackingReload = exports.TrackingReload = void 0;
var tslib_1 = require("tslib");
var heise_floodguard_1 = tslib_1.__importDefault(require("heise-floodguard"));
var TrackingReload = (function () {
    function TrackingReload() {
        this.floodguard = new heise_floodguard_1.default({
            event: 'tracking-reload',
            interval: 60,
            countPerInterval: 60,
        });
    }
    TrackingReload.prototype.setWebtrekk = function (object) {
        window.wt = object;
    };
    Object.defineProperty(TrackingReload.prototype, "wt", {
        get: function () {
            return window.wt;
        },
        enumerable: false,
        configurable: true
    });
    TrackingReload.prototype._replaceRandomParam = function (uri, param) {
        var regexp = new RegExp("(\\?|&)" + param + "=\\d+\\.\\d+");
        var newUri = uri.replace(regexp, "$1" + param + "=" + Math.random() * 100000);
        if (uri !== newUri) {
            return newUri;
        }
        if (uri.match(/\?/)) {
            return uri + "&" + param + "=" + Math.random() * 100000;
        }
        return uri + "?" + param + "=" + Math.random() * 100000;
    };
    TrackingReload.prototype.reloadIvw = function () {
        var ivwTag = document.querySelector('#ivw_pixel');
        if (ivwTag) {
            var replaced = this._replaceRandomParam(ivwTag.getAttribute('src') || '', 'd');
            ivwTag.setAttribute('src', replaced);
        }
        else {
            console.debug('IVW pixel missing');
        }
    };
    TrackingReload.prototype.reloadInfonlineBase = function () {
        var infonlineBaseProvider = document.querySelector('a-analytics[type="infonline-base"]');
        if (infonlineBaseProvider) {
            infonlineBaseProvider.reload();
        }
    };
    TrackingReload.prototype.reloadIntern = function (options) {
        if (options === void 0) { options = {}; }
        var tag = document.querySelector('#ivw_pixel_intern');
        var newSrc;
        if (!tag) {
            console.debug('intern pixel missing');
            return;
        }
        if (typeof tag.dataset.origSrc === 'undefined') {
            tag.dataset.origSrc = tag.getAttribute('src');
        }
        newSrc = this._replaceRandomParam(tag.dataset.origSrc, 'd');
        if (typeof options.num !== 'undefined') {
            newSrc = tag.dataset.origSrc.replace(/(.*?)(\?[^/]+)?$/, "$1/" + options.num + "$2");
        }
        tag.setAttribute('src', newSrc);
    };
    TrackingReload.prototype.reloadAvw = function () {
        var elem = document.querySelector('#avw_pixel_intern');
        if (elem) {
            var replaced = this._replaceRandomParam(elem.getAttribute('src') || '', 'd');
            elem.setAttribute('src', replaced);
        }
        else {
            console.debug('AVW pixel missing');
        }
    };
    Object.defineProperty(TrackingReload, "WEBTREKK_V3", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TrackingReload, "WEBTREKK_V5", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    TrackingReload.prototype._getWebtrekkVersion = function () {
        if (window._tiConfig) {
            return TrackingReload.WEBTREKK_V5;
        }
        if (window.wt) {
            return TrackingReload.WEBTREKK_V3;
        }
        return undefined;
    };
    TrackingReload.prototype.isWebtrekkV5Active = function () {
        return this._getWebtrekkVersion() === TrackingReload.WEBTREKK_V5;
    };
    TrackingReload.prototype.reloadWebtrekk = function (options, requestType) {
        if (requestType === void 0) { requestType = 'page'; }
        if (typeof this._getWebtrekkVersion() === 'undefined') {
            return;
        }
        if (!this.isWebtrekkV5Active()) {
            window.wt.sendinfo(options);
            return;
        }
        window.wts.push(['send', requestType, options]);
    };
    TrackingReload.prototype.getWebtrekk = function () {
        if (!this.isWebtrekkV5Active()) {
            return window.wt;
        }
        return window._tiConfig;
    };
    TrackingReload.prototype.reloadAll = function (args) {
        if (!this.floodguard.hasRemainingActions()) {
            console.error('denied');
            return;
        }
        if (typeof args === 'function') {
            args = args({
                webtrekk: this.getWebtrekk(),
            });
        }
        this.reloadAvw();
        this.reloadIntern(args === null || args === void 0 ? void 0 : args.reloadIntern);
        this.reloadWebtrekk(args === null || args === void 0 ? void 0 : args.reloadWebtrekk);
        this.reloadInfonlineBase();
    };
    return TrackingReload;
}());
exports.TrackingReload = TrackingReload;
exports.trackingReload = new TrackingReload();
